import moment from 'moment';

export const getElapsedTime = (endTime, startTime, elapsedTime) => {
  const ms = endTime > startTime ? moment(endTime).diff(moment(startTime)) : moment(startTime).diff(moment(endTime));
  const duration = moment.duration(ms);
  if (elapsedTime) {
    duration.add(elapsedTime, 'seconds');
  }
  
  return duration;
};

export const getElapsedTimeLikeString = (startTime, elapsedTime) => {
  const endTime = moment();
  const duration = getElapsedTime(endTime, startTime, elapsedTime);
  
  const elapsedDays = duration.days() > 0 ? `${duration.days()}d` : '';
  const hours = formatNumber(duration.hours());
  const minutes = formatNumber(duration.minutes());
  const seconds = formatNumber(duration.seconds());

  return `${elapsedDays} ${hours}:${minutes}:${seconds}`;
};

function formatNumber(number) {
  if (number < 10) {
    return `0${number}`;
  }
  return number;
}

export const timeConvertToDhms = (daysInDecimals) => {
  if (!daysInDecimals) {
    return null;
  }

  const days = Math.trunc(daysInDecimals);
  const decimals = daysInDecimals.toString().split('.')[1];
  if (!decimals) {
    return `${days} D`;
  }

  const totalSeconds = parseFloat(`0.${decimals}`) * 24 * 3600;

  const h = Math.floor(totalSeconds % (3600 * 24) / 3600);
  const m = Math.floor(totalSeconds % 3600 / 60);

  const dDisplay = days ? `${days}D ` : '';
  const hDisplay = h ? `${formatNumber(h)}` : '00';
  const mDisplay = m ? `:${formatNumber(m)}` : ':00';

  return dDisplay + hDisplay + mDisplay;
};

export const sleep = (milliseconds) => {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
};

